import Vue from 'vue'
import Router from 'vue-router'
import Content from '@/layout/App'
import store from '@/store'

// Auth
import Login from '@/pages/auth/Login'
import Home from '@/pages/home/Home'

// Customer
import MyAppointments from '@/pages/calendar/MyAppointments'

// Administrador
import Administratores from '@/pages/users/Administratores'
import Customers from '@/pages/users/Customers'
import Guia from '@/pages/users/Guia'
import Categories from '@/pages/categories/Categories'
import DisableDates from '@/pages/disabledates/DisableDates'
import Schedules from '@/pages/schedules/Schedules'
import Calendar from '@/pages/calendar/Calendar'
import Config from '@/pages/config/Config'

Vue.use(Router)
// const routesWithPrefix = (prefix, routes) => {
//   return routes.map(route => {
//     route.path = `${prefix}${route.path}`
//     return route
//   })
// }

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Content,
      meta: { requiresAuth: false },
      children: [
        {
          path: '/',
          name: 'Home',
          component: Home
        },
        {
          path: '/login',
          name: 'Login',
          component: Login
        }
      ]
    },
    {
      path: '/',
      component: Content,
      meta: { requiresAuth: true },
      children: [
        {
          path: '/my/appointments',
          name: 'MyAppointments',
          component: MyAppointments,
          meta: { role: [0, 1, 2] }
        },
        {
          path: '/calendar',
          name: 'Calendar',
          component: Calendar,
          meta: { role: [1, 2] }
        },
        {
          path: '/categories',
          name: 'Categories',
          component: Categories,
          meta: { role: [1] }
        },
        {
          path: '/schedules',
          name: 'Schedules',
          component: Schedules,
          meta: { role: [1] }
        },
        {
          path: '/disable-dates',
          name: 'DisableDates',
          component: DisableDates,
          meta: { role: [1] }
        },
        {
          path: '/users/administratores',
          name: 'Administratores',
          component: Administratores,
          meta: { role: [1] }
        },
        {
          path: '/users/customers',
          name: 'Customers',
          component: Customers,
          meta: { role: [1] }
        },
        {
          path: '/users/guia',
          name: 'Guia',
          component: Guia,
          meta: { role: [1] }
        },
        {
          path: '/config',
          name: 'Config',
          component: Config,
          meta: { role: [1] }
        }
        // ])
      ]
    }
  ],
  linkExactActiveClass: 'active selected'
})

router.beforeEach(async (to, from, next) => {
  const ignores = ['P401', 'P403', 'P404', 'Home'].includes(to.name)
  const { role } = store.getters.user ? store.getters.user : { role: '' }
  console.log('rol: ' + role)
  console.log('rol page: ' + to.meta.role)
  console.log(to.meta.role)
  console.log()
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.access_token) {
      if (ignores) {
        next()
      } else {
        if ((to.meta.role || []).includes(role)) {
          next()
        } else {
          next({ name: 'Home' })
        }
      }
    } else {
      next({ name: 'Login' })
    }
  } else {
    if (store.getters.access_token) {
      if (ignores) {
        next()
      } else {
        if ((to.meta.role || []).includes(role)) {
          next()
        } else {
          next({ name: 'Home' })
        }
      }
    } else {
      next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js